import {
  IMockProps,
  ErrorResponseCodeType,
  Mocks,
  MockServiceType,
} from '../../Core';
import { CODE_ERRORS, ENDPOINT_API_PATH } from '../../Apis/GetCmsContentApi';
import { CmsContentTypes } from '../../Types';
import { CmsContentMocksDef } from '../../Mocks';

const mocksSuccess: IMockProps[] = [];

let mocksErrors: IMockProps[] = [];

const generateSuccess = (
  params: CmsContentTypes.CmsContentRequestType,
): IMockProps => {
  return {
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
      params,
    },
    configResponse: {
      status: 200,
      data: CmsContentMocksDef.CMS_CONTENT_RESPONSE,
    },
  };
};

const generateDefaultErrors = (
  params: CmsContentTypes.CmsContentRequestType,
): IMockProps[] => {
  return CODE_ERRORS.map(
    (error: ErrorResponseCodeType<null>, index: number): IMockProps => {
      return {
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          params: {
            category: `${params.category}-${index}`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };
    },
  );
};

mocksSuccess.push(
  generateSuccess({
    category: 'sao_paulo',
  }),
);
mocksErrors = mocksErrors.concat(
  generateDefaultErrors({
    category: 'sao_paulo',
  }),
);

export const mocksService: MockServiceType<CmsContentTypes.CmsContentRequestType>[] =
  mocksSuccess.map((request) => ({
    label: `[Sucesso] - ${JSON.stringify(request.configRequest.params)}`,
    value: request.configRequest.params,
  }));

const allMocks: IMockProps[] = mocksSuccess.concat(mocksErrors);

Mocks.getInstance().addAll(allMocks);
